export class PaymentType {

  static readonly PREPAYMENT = 'pre';
  static readonly FINAL_PAYMENT = 'final';
  static readonly PAID_DIRECT = 'direct';
  static readonly EVENT_CANCELLED = 'cancelled';
  static readonly INITIAL = 'initial';

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/models/payment-type.ts